/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */
import StepeperProcesos from "../stepperProcesos";
export default function PreOperatorio() {
  const steps = [
    {
      numero: "1",
      titulo: "CONTACTAR ESF",
      pasos: ["Vía Telefónica, Correo electrónico, página Web."],
      roles: [],
    },
    {
      numero: "2",
      titulo: "MANDAR PRE-CANDIDATO",
      pasos: [
        "- Liga para solicitud",
        "- Carta de presentación",
        "- Cuestionario de Expectativas",
        "- Solicitar Documentación Administrativa",
        "- Solicitar Estudios realizados a la fecha",
      ],
      roles: [98],
    },
    {
      numero: "3",
      titulo: "RECEPCIÓN DOCUMENTOS",
      pasos: [
        "- Solicitud",
        "- Acta Nacimiento menor",
        "- CURP menor y ambos padres",
        "- Identificaciones oficiales ambos padres",
        "- Comprobante de Domicilio",
        "- Cartilla de Vacunación",
        "- Carta de presentación firmada",
        "- Cuestionario de Expectativas contestado",
        "- Estudios realizados a la fecha",
      ],
      roles: [98],
    },
    {
      numero: "4",
      titulo: "REVISAR Y VALIDAR INFORMACIÓN RECIBIDA",
      pasos: ["Programar Estudio Socioeconómico"],
      roles: [98],
    },
    {
      numero: "5",
      titulo: "VALORACIONES PRESENCIALES",
      pasos: [
        "Agendar:",
        "- Resonancia Magnética",
        "- Tomografía",
        "- Estudios Neurofisiologicos",
        "- Estudios Conductuales",
        "- Entrevista de Rehabilitación",
        "- Entrevista de Acompañamiento",
        "- Evaluación del Desarrollo",
        "- Valoración ORL",
      ],
      roles: [98],
    },
    {
      numero: "6",
      titulo: "SUBIR A SOLICITUDES",
      pasos: [
        "- Informes de Valoraciones de especialistas",
        "- Resultados e Interpretaciones de Estudios",
      ],
      roles: [93, 99],
    },
    {
      numero: "7",
      titulo: "PRESENTACIÓN",
      pasos: ["Subir Presentación para Reunión Nacional."],
      roles: [93, 99],
    },
    {
      numero: "8",
      titulo: "PRESENTACIÓN",
      pasos: ["Subir Presentación para Reunión Internacional."],
      roles: [93, 99],
    },
    {
      numero: "9",
      titulo: "RESOLUCIÓN",
      pasos: [
        "Agendar llamada para dar resolución al Pre-Candidato.",
        "* En caso de ser aceptado la solicitud se convierte en EXPEDIENTE.",
      ],
      roles: [98],
    },
    {
      numero: "10",
      titulo: "PROGRAMAR FECHA DE CIRUGIA",
      pasos: [
        "- Fecha de cirugía",
        "- Responsable de ORL.",
        "- Responsable de Audiología.",
        "- Responsable de Anestesiología",
      ],
      roles: [98],
    },
    {
      numero: "11",
      titulo: "ESTUDIOS Y VALORACIONES PRESENCIALES",
      pasos: [
        "Agendar:",
        "- Estudios Preoperatorios LAPI",
        "- Valoración Pediatra",
        "- Valoración Oftalmóloga",
        "- Valoración Vestibular",
        "- Valoración ORL",
        "- Valoración Genética",
        "- Electrocardiograma",
        "- Ultrasonido Renal",
        "- Entrevista Acompañamiento Emocional",
      ],
      roles: [98],
    },
    {
      numero: "12",
      titulo: "SUBIR A EXPEDIENTE",
      pasos: [
        "- Informes de Valoraciones de especialistas",
        "- Resultados e Interpretaciones de Estudios",
      ],
      roles: [93, 99],
    },
  ];

  return <StepeperProcesos steps={steps} />;
}
